export const coordinatesAreInViewport = (y11, y12, y21, y22) => {
    y21 = y21 === undefined ? window.scrollY : y21;
    y22 = y22 === undefined ? window.scrollY + window.innerHeight : y22;
    return !((y11 < y21 && y12 < y21 || y11 > y22 && y12 > y22))
}

export const initDomPrototypes = () => {
    Element.prototype.isInViewport = function (overflow) {
        overflow = overflow || 0;
        const rect = this.getBoundingClientRect();
        try {
            return coordinatesAreInViewport(rect.top, rect.top + this.clientHeight, 0 - overflow, window.innerHeight + overflow)
        } catch (e) {
            return false;
        }
    }
}